import { useTranslation } from 'react-i18next';
import { Form } from '@anytag/shared-atoms';
import { TextSearchField, SingleDatePickerField } from '@anytag/shared-molecules';
import { TagType, TagsList, TagsListProps, TagsAnalyticsFilterFormKeys } from '../../shared';
import { useCreateDeleteTiktokTag, useExportTiktokTagsAnalyticsFile } from './hooks';

export interface TemplateProps extends Pick<TagsListProps, 'tags' | 'onSubmit'> {
  tagType: TagType;
  countryId: string;
}

export const Template = ({ tags, tagType, onSubmit, countryId }: TemplateProps) => {
  const { t } = useTranslation();
  const { ExportButton, ExportModal } = useExportTiktokTagsAnalyticsFile({ tagType });
  const { handleCreateTag, handleDeleteTag, creating, deleting } = useCreateDeleteTiktokTag({ tagType, countryId });

  return (
    <>
      <TagsList
        tags={tags}
        tagType={tagType}
        onSubmit={onSubmit}
        creating={creating}
        deleting={deleting}
        countryId={countryId}
        onCreateTag={handleCreateTag}
        onDeleteTag={handleDeleteTag}
      />

      <Form.Fields className="mt-2">
        <TextSearchField<TagsAnalyticsFilterFormKeys>
          name="keyword"
          onSubmit={onSubmit}
          placeholder={t<string>('hashtagsAnalyticsKeywordPlaceholder')}
        />

        <SingleDatePickerField<TagsAnalyticsFilterFormKeys>
          name="date"
          clearable={false}
          onSubmit={onSubmit}
          className="w-[184px] flex-none"
          disabledDays={{ after: new Date() }}
          required
        />

        <Form.Field className="flex-none">
          <ExportButton />
        </Form.Field>
      </Form.Fields>

      {ExportModal}
    </>
  );
};
